export default __webpack_public_path__ + "static/media/03.c4860d5d.png";